(() => {
  function pad(n) {
    return String(n).padStart(2, "0");
  }

  // Retorna o timestamp do próximo SÁBADO 23:59:59 (no fuso do navegador)
  function getNextSaturdayEndTs(now = new Date()) {
    const day = now.getDay(); // 0=Dom, 6=Sáb
    let daysUntilSat = (6 - day + 7) % 7;

    const end = new Date(now);
    end.setHours(23, 59, 59, 999);

    // Se hoje já é sábado e já passou de 23:59:59, vai pro próximo sábado
    if (daysUntilSat === 0 && now.getTime() > end.getTime()) {
      daysUntilSat = 7;
    }

    const target = new Date(now);
    target.setDate(now.getDate() + daysUntilSat);
    target.setHours(23, 59, 59, 0);

    return target.getTime();
  }

  function formatHHMMSS(ms) {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  function tick() {
    const now = new Date();
    const endTs = getNextSaturdayEndTs(now);

    document.querySelectorAll("[data-weekly-countdown]").forEach((el) => {
      const timeEl = el.querySelector("[data-countdown-time]");
      if (!timeEl) return;

      const diff = endTs - now.getTime();
      timeEl.textContent = formatHHMMSS(diff);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    tick();
    setInterval(tick, 1000);
  });
})();
